var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "holiday-rule-root",
      class: { "no-sort": !(_vm.prize1 && _vm.prize1.rank) },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: _vm.$t("lang.commonM.k111"), "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "bg-block" }, [
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k230"))),
          ]),
          _vm.actStartTime && _vm.actEndTime
            ? _c("div", { staticClass: "item-txt" }, [
                _vm._v(" 1. " + _vm._s(_vm.$t("lang.commonM.k231")) + ": "),
                _c("br"),
                _c("i", { staticStyle: { color: "#ff9524" } }, [
                  _vm._v(
                    _vm._s(_vm.actStartTime) + " - " + _vm._s(_vm.actEndTime)
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k251"))),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k233"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k248"))),
          ]),
          _c(
            "div",
            { staticClass: "gift-num", staticStyle: { "margin-top": "16px" } },
            [
              _c("div", [
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Gem.png"),
                    alt: "",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k454")) + " "),
              ]),
              _c("span", [
                _c("i", [_vm._v("1")]),
                _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
              ]),
            ]
          ),
          _c("div", { staticClass: "gift-num" }, [
            _c("div", [
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/common/Ring.png"),
                  alt: "",
                },
              }),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k211")) + " "),
            ]),
            _c("span", [
              _c("i", [_vm._v("3")]),
              _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
            ]),
          ]),
          _c("div", { staticClass: "gift-num" }, [
            _c("div", [
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/common/Fireworks.png"),
                  alt: "",
                },
              }),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k451")) + " "),
            ]),
            _c("span", [
              _c("i", [_vm._v("7")]),
              _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
            ]),
          ]),
          _c("div", { staticClass: "gift-num" }, [
            _c("div", [
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/common/Kiss.png"),
                  alt: "",
                },
              }),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k305")) + " "),
            ]),
            _c("span", [
              _c("i", [_vm._v("15")]),
              _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
            ]),
          ]),
          _c("div", { staticClass: "gift-num" }, [
            _c("div", [
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/common/Candy.png"),
                  alt: "",
                },
              }),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k214")) + " "),
            ]),
            _c("span", [
              _c("i", [_vm._v("80")]),
              _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k218"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k431"))),
          ]),
          _vm.actEndTime
            ? _c("div", { staticClass: "item-txt" }, [
                _vm._v(" 2. " + _vm._s(_vm.$t("lang.commonM.k432")) + " "),
                _c("br"),
                _c("i", { staticStyle: { color: "#ff9524" } }, [
                  _vm._v(_vm._s(_vm.actEndTime)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("3. " + _vm._s(_vm.$t("lang.commonM.k433"))),
          ]),
          _c(
            "div",
            {
              staticClass: "reward-item",
              staticStyle: { "margin-top": "16px" },
            },
            [
              _c("div", { staticClass: "reward-num" }, [_vm._v("No.1")]),
              _c("div", { staticClass: "reward-coins" }, [
                _vm._v(" 1000 "),
                _c("img", {
                  staticClass: "coins-icon",
                  attrs: { src: _vm.getMatchImg("coin") },
                }),
              ]),
            ]
          ),
          _c("div", { staticClass: "reward-item" }, [
            _c("div", { staticClass: "reward-num" }, [_vm._v("No.2")]),
            _c("div", { staticClass: "reward-coins" }, [
              _vm._v(" 700 "),
              _c("img", {
                staticClass: "coins-icon",
                attrs: { src: _vm.getMatchImg("coin") },
              }),
            ]),
          ]),
          _c("div", { staticClass: "reward-item" }, [
            _c("div", { staticClass: "reward-num" }, [_vm._v("No.3")]),
            _c("div", { staticClass: "reward-coins" }, [
              _vm._v(" 500 "),
              _c("img", {
                staticClass: "coins-icon",
                attrs: { src: _vm.getMatchImg("coin") },
              }),
            ]),
          ]),
          _c("div", { staticClass: "reward-item" }, [
            _c("div", { staticClass: "reward-num" }, [_vm._v("No.4-10")]),
            _c("div", { staticClass: "reward-coins" }, [
              _vm._v(" 80 "),
              _c("img", {
                staticClass: "coins-icon",
                attrs: { src: _vm.getMatchImg("coin") },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k201"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k434"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k204"))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }